/**
 * copiarSoape — vuelca la nota S·O·A·P·E al portapapeles como texto plano.
 *
 * Se comparte entre la consulta en vivo y el detalle del historial para que el
 * pegado sea idéntico venga de donde venga (mismos títulos, mismo orden, las
 * secciones vacías fuera).
 */

export interface SoapTexto {
  s?: string;
  o?: string;
  a?: string;
  p?: string;
  e?: string;
}

const SECCIONES: ReadonlyArray<readonly [keyof SoapTexto, string]> = [
  ['s', 'SUBJETIVO'],
  ['o', 'OBJETIVO'],
  ['a', 'ANÁLISIS'],
  ['p', 'PLAN'],
  ['e', 'EVOLUCIÓN'],
];

export function soapeATexto(soap: SoapTexto): string {
  return SECCIONES
    .filter(([k]) => (soap[k] ?? '').trim())
    .map(([k, titulo]) => `${titulo}\n${(soap[k] ?? '').trim()}`)
    .join('\n\n');
}

async function escribirPortapapeles(texto: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(texto);
  } catch {
    // `writeText` falla si la ventana no tiene foco: respaldo universal.
    const ta = document.createElement('textarea');
    ta.value = texto;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } finally { document.body.removeChild(ta); }
  }
}

/** Devuelve `true` si algo se copió. */
export async function copiarSoape(soap: SoapTexto): Promise<boolean> {
  const texto = soapeATexto(soap);
  if (!texto) return false;
  await escribirPortapapeles(texto);
  return true;
}

/** Copia únicamente el texto que el médico tiene sombreado/seleccionado en la página. */
export async function copiarSeleccionActual(): Promise<boolean> {
  const texto = window.getSelection?.()?.toString().trim() ?? '';
  if (!texto) return false;
  await escribirPortapapeles(texto);
  return true;
}
